import styled from "styled-components";
import { Flex } from "components/common";

export const ErrorWrapper = styled(Flex)`
  padding: 24px;
  flex-direction: column;
`;

export const ErrorCard = styled.div`
  max-width: 440px;
  width: 100%;
  padding: 28px;
  border-radius: 16px;
  background: #111827;
  border: 1px solid #1f2937;
  text-align: center;
`;

export const ErrorTitle = styled.h2`
  margin: 0 0 10px;
  color: #f9fafb;
  font-size: 22px;
  font-weight: 700;
`;

export const ErrorText = styled.p`
  margin: 0;
  color: #d1d5db;
  font-size: 15px;
  line-height: 1.5;
`;

export const ErrorSubText = styled.p`
  margin: 10px 0 0;
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.4;
`;
